module.exports = {
  QuickEntry: 'ショートカットエントリ',
  LastRefreshTime: '最終更新日',
  SopBoard: 'SOP看板',
  SeaExport: '海運輸出',
  SeaImport: '海運輸入',
  AirExport: '航空輸出',
  AirImport: '航空輸入',
  RailwayExport: 'RailwayExport',
  RailwayImport: 'RailwayImport',
  IntegratedJob: 'Integrated Job',
  BusinessVolumeGraph: 'BusinessVolumeGraph',
  PackUp: '集める',
  Unfold: '展開',
  SopReveal: 'SOPReveal',
  SopFilterConditions: 'SOPFilterConditions',
  SaveSucceed: 'Saved successfully',
  QuickEntryPopover: {
    FirstLine: '1.メニューバーから任意の機能をショートカットポータルにドラッグ＆ドロップできます',
    SecondLine: '2.ショートカットが多すぎて1行に収まらない場合は、自動的に新しい行に表示されます'
  },
  SopBoardPopover: {
    FirstLine: '1.SOPパネルは、閲覧可能なサービスのみをカウントし、チェックを入れたノードと処理状況のみを表示します。',
    SecondLine: '2.サービスのノード処理状況が「完了」になると、このノードには表示されなくなります。',
    ThirdLine: '3.ノードの上にカーソルを移動すると、チェックを入れたノードの処理状況とそれに対応するビジネスの数が表示されます。',
    FourthLine: '4.ノードをクリックするか、処理状況をクリックすると、対応するビジネス機能にジャンプし、対応するビジネスをチェックアウトすることができます。'
  },
  LineChartPopover: {
    FirstLine: '1、The traffic graph only shows the number of new business related to you in the last seven days.'
  },
  SopFilterContent: {
    SopFilterConditionsTip: 'Businesses that meet any of the following criteria will be counted in the SOP board',
    BusinessState: 'By business status',
    Operation: 'Is the operation',
    Submit: 'Has been submitted',
    Audit: 'The approved',
    Date: 'By date of business',
    ETD: 'Business Date (ETD) not earlier than',
    ETA: 'Business Date (ETA) not earlier than',
    Days: 'days before',
    PleaseInputDays: 'Please enter number of days',
    PleaseSelectBusinessType: 'Please select at least one business state',
    PreCommit: 'PreCommit'
  },
  QuickEntryLayer: {
    FirstLine: 'Click here for quick access to the function',
    SecondLine: 'Drag and drop the shortcut entry directly from the menu'
  },
  SopBoardLayer: {
    FirstLine: '1、The SOP nodes you are interested in are shown here',
    SecondLine: '2、Move the mouse over the node to display the number of businesses in each state under the node',
    ThirdLine: '3、The nodes and states shown are freely configurable'
  },
  LineChartLayer: {
    FirstLine: 'This shows the number of new business related to you in the last seven days'
  },
  SettingLayer: {
    FirstLine: 'Click here to take you to the configuration page'
  },
  NextStep: 'The next step',
  Loading: 'Loading',
  hasPermission: 'Sorry, You do not have permission',
  warningMessage: 'Warning message',
  ignoreMessage: '無視',
  ignoreSelected: 'Ignore selected',
  restoreSelected: 'Restore selected',
  ScreeningContent: 'Screening content:',
  Warning: 'Give early warning',
  nodeName: 'Node Name',
  nodeState: 'Node State',
  warningLevel: 'Warning Level',
  warningAt: 'Warning Time',
  warningContent: 'Warning Content',
  sift: 'Sift',
  toDoList: 'ToDoリスト',
  SopWarning: 'SOP早期警報',
  DelTrackingDetailConfirm: 'Note: The associated business details and sop nodes will be deleted',
  DelTrackingConfirm: 'Do you want to delete the node? After the node is deleted, the node of the related business document is also deleted.',
  copyTrackingTemplateConfirm: 'Copy the {0} template?',
  SelectTheNode: 'Select the node',
  StatusType: 'Status Type',
  AutomaticTriggering: 'Automatic triggering',
  ExternalEncoding: 'External encoding',
  ReportTemplate: 'Report Template',
  SendNotifications: 'Send notifications',
  NotSendNotifications: 'Send notifications',
  InitialState: 'Initial state'
}
